import React from 'react';

import {buildCatalogMap, getParents} from '../../lib/catalog';
import {default as CatalogInput2} from '../CatalogInput';
import {getQuestionMetadata} from '../../screens/FormBuilderScreen/shared';

//an answer is always a leaf item, from one of the catalog types the question is restricted to when it has any

function CatalogInput({id, question, label, catalog, values, onChange, invalid, autoOpen}) {
  const catalogById = buildCatalogMap(catalog);
  let value = null;

  if (values[0]) {
    const ids = values[0].split(',');
    value = ids[ids.length - 1];
  }

  return (
    <CatalogInput2
      id={id}
      label={label}
      catalog={catalog}
      selectableTypeIds={getQuestionMetadata(question, 'selectedTypes')}
      leafOnly
      autoOpen={autoOpen}
      value={value}
      onChange={itemId => {
        const item = catalogById[itemId];
        const parents = getParents(item, catalogById).reverse();

        onChange([[...parents, item].map(item => item.id).join(',')], true);
      }}
      invalid={invalid}
    />
  );
}

export default CatalogInput;
